export const LIB_VERSION_CODE = 70847;
export const LIB_VERSION_NAME = "7.8.47";
